import React from "react";
import Grid from "@material-ui/core/Grid/Grid";
import Person from "./person/person.js";
import Address from "./address";

export default function PersonInformation(props) {
  const { type, values = {}, element = {}, setStateValues } = props;
  const { text = "" } = element;
  const topStyle = {
    paddingBottom: 0,
  };
  const bottomStyle = {
    marginTop: "12px",
  };

  return (
    <div className="person-information">
      <h3>{text}</h3>
      <Grid container>
        <Grid item xs={12} sm={10} style={topStyle}>
          <Person id="person" answer={values.value && values.value.person} setStateValues={onSetValue} type={type} />
        </Grid>
        <Grid item xs={12} sm={10} style={bottomStyle}>
          <Address id="address" answer={values.value && values.value.address && { value: values.value.address }} setStateValues={onSetValue} type={type} />
        </Grid>
      </Grid>
    </div>
  );

  function onSetValue(id, type, value) {
    const itemValue = {
      ...values.value,
      [id]: value,
    };

    setStateValues(element.id, type, itemValue);
  }
}
